import { MINIMUM_ACCEPTED_AUDIO_DURATION } from '@modals/PriceModal/constants';

export const errors: {
  [key: string]: string;
} = {
  'err.duration': `Minimum duration accepted is ${MINIMUM_ACCEPTED_AUDIO_DURATION} seconds`,
  'err.internal': 'Internal server error',
  'err.unauthenticated': 'Authentication required',
  'err.password.not_matches': "Passwords don't match",
  'err.user.inactive': 'User blocked, contact administrator',
  'err.user.not_found': 'User not found, contact administrator',
  'err.user.password_invalid': 'Invalid password',
  'err.operation.forbidden': 'Forbidden',
  'err.property.restricted': "Property can't be modified",
  'err.item.not_found': 'Item not found',
  'err.registration.too_many_attempts': 'Too many attempts, please wait 1 hour',
  'err.registration.email_already_registered': 'Email already registered',
  'err.registration.email_not_registered': 'Email not registered',
  'err.recovery.too_many_attempts': 'Too many attempts, please wait 1 hour',
  'err.validation.invalid_email': 'Invalid email',
  'err.validation.invalid_account_type': 'Invalid account type',
  'err.password.to_small': 'Password must contain at least 8 characters',
  'err.password.to_large': 'Password must contain no more than 256 characters',
  'err.password.edge_space': "Password can't start or end with a space",
  'err.password.no_num': 'Password must contain at least one number',
  'err.password.no_lowercase': 'Password must contain at least one lowercase character',
  'err.password.no_uppercase': 'Password must contain at least one uppercase character',
  'err.password.no_letter': 'Password must contain at least one letter',
  'err.password.no_symbol':
    "Password must contain at least one keyboard symbol, such as ! @ # $ % . - +. Characters like £ or € don't count",
  'Incorrect username or password': 'Incorrect username or password',
  NotAuthorizedException: 'Invalid username or password',
  UserNotConfirmedException: 'User email is not confirmed',
  UserNotFoundException: 'User not found, contact administrator',
  FeatureNotEnabled: 'The specified user does not have this product enabled. Contact the administrator',
  'An account with the given email already exists.': 'An account with the given email already exists.',
  'err.voicescriptEmail': 'Please use an email belonging to voicescript.ai',
  'err.legalproofsEmail':
    'Only @voicescript.ai and @legalproofs.com emails are allowed. For publicly available platform visit <a href="https://autoscript.ai" target="_blank" rel="noreferrer">autoscript.ai</a>',
  'err.agreement': 'Please agree to the terms and conditions',
  'err.ssoProvider': "Please use your company's SSO provider to login",
  SSO_EMAIL_CLAIM_MISSING:
    'Your company identity provider did not return an email address. Contact your administrator.',
  SSO_EMAIL_MISMATCH: 'The company identity did not match the requested account.',
  SSO_EMAIL_NOT_VERIFIED:
    'Your company identity provider did not verify this email address. Contact your administrator.',
  SSO_IDENTITY_ALREADY_LINKED: 'This company identity is already linked to another account. Contact support.',
  SSO_AMBIGUOUS_EMAIL_MATCH: 'Multiple accounts match this company identity. Contact support.',
  SSO_NOT_PROVISIONED:
    'Your account has not been provisioned for this workspace. Ask your administrator to invite you, then sign in again.',
  SSO_ONLY_AUTHENTICATION_REQUIRED:
    'This email is managed by your company single sign-on. Sign in with your company account instead.',
  SSO_ORG_CREATION_BLOCKED:
    'Your account is managed by your company single sign-on; workspaces are managed by your administrator.',
  'wrn.enhanced':
    'Enhanced Processing applies transcript cleanup that may replace any manual edits made during your session. Proceeding may result in loss of those changes',
};
